import { ComponentType } from "react";
import { LANGUAGE } from "_constants";
import { ReactComponent as PenaltyIcon } from "./assets/penalty.svg";
import { ReactComponent as GoalIcon } from "./assets/goal.svg";
import { ReactComponent as TimeoutIcon } from "./assets/timeout.svg";
import { ReactComponent as WhistleIcon } from "./assets/whistle.svg";
import { ReactComponent as PlayerIcon } from "./assets/player.svg";
import { ReactComponent as ShotIcon } from "./assets/shoot.svg";
import { ReactComponent as PenaltyShotIcon } from "./assets/penalty-shot.svg";
import { ReactComponent as PenaltyMissedIcon } from "./assets/penalty-missed.svg";
import { ReactComponent as PulledKeeperIcon } from "./assets/pulled-keeper.svg";
import { ReactComponent as FaceOffIcon } from "./assets/staff.svg";
import { ReactComponent as PuckDroppedIcon } from "./assets/puck-dropped.svg";
import { ReactComponent as PenaltyShootoutIcon } from "./assets/penalty-shoutout.svg";
//import { ReactComponent as OvertimeIcon } from "./assets/overtime.svg";

const MESSAGES_EN: Record<string, string> = {
  "1270": "On Possession",
  "1271": "Penalty",
  "1272": "Power Play Over",
  "1273": "Shot",
  "1274": "Goal",
  "1275": "Penalty Shot",
  "1276": "Penalty Shot Missed",
  "1277": "Pulled Keeper",
  "1278": "Keeper Back In Goal",
  "1280": "End of 2nd Period",
  "1281": "Overtime Start",
  "1282": "Overtime End",
  "1283": "Penalty Shootout",
  "1284": "Face Off",
  "1285": "Puck Dropped",
  "1286": "Face Off Winner",
  "1287": "Timeout",
  "1288": "Icing",
  "1289": "Power Play",
  "1292": "On Possession",
  "1295": "In Possession",
};

const MESSAGES_ALB: Record<string, string> = { ...MESSAGES_EN };

export const MESSAGES = {
  [LANGUAGE.ENGLISH]: MESSAGES_EN,
  [LANGUAGE.ALBANIAN]: MESSAGES_ALB,
};

export const SECONDARY_DICT: Record<number, Record<string, string>> = {
  [LANGUAGE.ALBANIAN]: {
    "End of 1st Period": "ALB:End of 1st Period",
    "End of 2nd Period": "ALB:End of 2nd Period",
  },
};

export const ICONS: Record<string, ComponentType<any>> = {
  "1271": PenaltyIcon,
  "1272": PlayerIcon,
  "1273": ShotIcon,
  "1274": GoalIcon,
  "1275": PenaltyShotIcon,
  "1276": PenaltyMissedIcon,
  "1277": PulledKeeperIcon,
  "1278": PlayerIcon,
  "1287": TimeoutIcon,
  "1280": WhistleIcon,
  "1281": TimeoutIcon,
  "1282": WhistleIcon,
  "1283": PenaltyShootoutIcon,
  "1284": FaceOffIcon,
  "1285": PuckDroppedIcon,
};

export const TIMER_PAUSE_EVENTS = [
  "1287", // Timeout
  "1271", // Penalty
  "1275", // Penalty Shot
  "1276", // Penalty Shot Missed
  "1280", // End of 2nd Period
  "1282", // Overtime End
  "1283", // Penalty Shootout
];

export const TIMER_CONTINUE_EVENTS = [
  "1270", // On Possession
  "1295", // In Possession
  "1273", // Shot
  "1274", // Goal
  "1284", // Face Off
  "1285", // Puck Dropped
  "1286", // Face Off Winner
  "1289", // Power Play
  "1292", // On Possession
];
